import { createWithEqualityFn } from 'zustand/traditional';
export const useChainSwitchModalStore = createWithEqualityFn((set) => ({
    isOpen: false,
    openModal: (desiredChain) => {
        const _controller = genPromiseController();
        set({
            _controller,
            isOpen: true,
            desiredChain,
        });
        return _controller;
    },
    closeModal: () => {
        set({ desiredChain: undefined, isOpen: false });
    },
}));
export const useWalletConnectModalStore = createWithEqualityFn((set) => ({
    isOpen: false,
    openModal: (desiredChain) => {
        const _controller = genPromiseController();
        set({
            _controller,
            isOpen: true,
            desiredChain,
        });
        return _controller;
    },
    closeModal: () => {
        set({ desiredChain: undefined, isOpen: false });
    },
}));
const genPromiseController = () => {
    let resolve = () => {
        //
    }, reject = () => {
        //
    };
    const promise = new Promise((resolve_, reject_) => {
        resolve = resolve_;
        reject = reject_;
    });
    // default catch
    promise.catch(() => {
        //
    });
    return {
        resolve,
        reject,
        promise,
    };
};
